<app-service-slider
  heading="services.whats-new"
  subHeading="services.whats-new-desc"
  srvNameKey="en_sname"
  displayKey="serviceName"
  logoUrlKey="image"
  srvIdKey="serviceId"
  [isLoading]="isLoading"
  [services]="whatsNewServices"
  [isWhatsNew]="true"
></app-service-slider>
